import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Container, Grid, Link, Typography } from "@mui/material";

import { globalVariables } from "../../global/GlobalVariables";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function Support(params) {
  const { t } = useTranslation("translation", { keyPrefix: "pages.support" });

  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid
          container
          sx={{
            gap: 2,
            p: 2
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
            }}
          >
            <Typography variant="h3" gutterBottom>
              Support
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
            }}
          >
            <Typography variant="body1" paragraph>
              {t("needHelpDescription")}
            </Typography>
            <Typography variant="body1" paragraph>
              <Link href={globalVariables()?.site?.supportUrl} target="_blank">
                {globalVariables()?.site?.supportUrl}
              </Link>
            </Typography>
            <Typography variant="body1" paragraph>
              {t("questionsPrompt")}
            </Typography>
            <Typography variant="body1" paragraph>
              <Link
                href={`mailto:${
                  getEnvironmentVariable("COMPANY_SUPPORT_EMAIL") ||
                  "support@bestcoastpairings.com"
                }`}
                underline="none"
              >
                {getEnvironmentVariable("COMPANY_SUPPORT_EMAIL") ||
                  "support@bestcoastpairings.com"}
              </Link>
            </Typography>
            {getEnvironmentVariable("COMPANY_SUGGESTIONS_EMAIL") && (
              <>
                <Typography variant="body1" paragraph>
                  {t("suggestionsPrompt")}
                </Typography>

                <Typography variant="body1" paragraph>
                  <Link
                    href={`mailto:${
                      getEnvironmentVariable("COMPANY_SUGGESTIONS_EMAIL") ||
                      "suggestions@bestcoastpairings.com"
                    }`}
                    underline="none"
                  >
                    {getEnvironmentVariable("COMPANY_SUGGESTIONS_EMAIL") ||
                      "suggestions@bestcoastpairings.com"}
                  </Link>
                </Typography>
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
